import zh from './zh'
import ko from './ko'
export default {
  zh,
  ko
}
